<template>
  <div class="adminmodelliadd">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Modifica un modello</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="descrizione" v-model="formData.modello.descrizione" :state="state.descrizione" rows="3" max-rows="6" /><label for="descrizione">* Descrizione</label>
          <br>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col>
          <h3>Carica un nuovo modello</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="10">
          <file-pond :files="file" ref="pond" label-idle="* Clicca qui o trascina il modello da caricare" allow-multiple="false" max-files="1"/>
        </b-col>
        <b-col cols="12" md="2">
          <b-button size="lg" variant="primary" v-on:click="addVersioneModello()"><font-awesome-icon icon="file-upload" /> Carica</b-button>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>VERSIONI DEL MODELLO</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="formData.modello.versioni"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button size="sm" variant="danger" v-on:click="openModalDeleteVersioneModello(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button size="sm" variant="success" style="margin-left: 10px;" v-on:click="downloadModelo(row.item)"><font-awesome-icon icon="file-download" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateModello()"><font-awesome-icon icon="marker" /> Modifica</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare la versione del modello <strong>n. {{modalData.delete.versione}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteVersioneModello(modalData.delete.versione)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)

export default {
  name: 'adminmodelliadd',
  data() {
    return {
      campi: [
        {key: 'originalname', label: 'Nome file', sortable: true},
        {key: 'versione', label: 'Versione', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 4,
      filter: null,

      file: [],
      
      modal: {
        delete: false
      },
      modalData: {
        delete: {}
      },
      state: {
        descrizione: null
      },
      formData:{
        modello: {
          descrizione: '',
          versioni: []
        }
      }
    }
  },
  components: {
    FilePond
  },
  created: function(){
    this.loadModello()
  },
  methods: {
    updateModello(){
      Vue.http.post('admin/modello/update/'+this.$route.params.id, {descrizione: this.formData.modello.descrizione}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Modello aggiornata con successo!',
            type: 'success'
          })
          this.$router.push('/admin/modelli')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadModello(parziale=false){
      Vue.http.post('admin/modello/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          var x
          if(parziale)
            x = this.formData.modello.descrizione

          this.formData = response.body.data

          this.totalRows = this.formData.modello.versioni.length

          if(parziale)
            this.formData.modello.descrizione = x
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    },
    addVersioneModello(){
      if(this.$refs.pond.getFiles().length > 0){
        var formSend = new FormData()
        formSend.append('modello', this.$refs.pond.getFiles()[0].file, this.$refs.pond.getFiles()[0].file.name)
        formSend.append('idModello', this.$route.params.id)
        
        console.log(formSend)
        Vue.http.post('admin/modello/addversione', formSend, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            credentials : true
        }).then(response => {
          if(response.body.success){
            Vue.notify({
              group: 'global',
              title: 'Operazione riuscita!',
              text: 'Nuova versione del modello aggiunto con successo!',
              type: 'success'
            })
            this.file = []
            this.loadModello(true)
          }else{
            for(var i=0; i<Object.keys(this.state).length; i++){
              this.state[Object.keys(this.state)[i]] = null
            }

            for(var i=0; i<response.body.inputError.length; i++){
              this.state[response.body.inputError[i]] = false
            }

            Vue.notify({
              group: 'global',
              title: 'Problemi durante la registrazione',
              text: response.body.msg,
              type: 'error'
            })
          }
        }, response => {})
      }else{
        Vue.notify({
          group: 'global',
          title: 'Problemi durante la registrazione',
          text: "Assicurati di aver selezionato correttamente un file!",
          type: 'error'
        })
      }
    },
    downloadModelo(item){
      window.open(Vue.prototype.$hostlink+"admin/modello/download/"+this.$route.params.id+"/"+item.versione)
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteVersioneModello(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deleteVersioneModello(versione){
      Vue.http.post('admin/modello/deleteversione', {idModello: this.$route.params.id, versione: versione}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadModello(true)
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Versione del modello eliminato correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  }
}
</script>

<style>
.adminmodelliadd #descrizione{
  text-indent: 120px;
  line-height: 1.8;
}
</style>